// src/services/tmdbApi.js
import axios from 'axios';

const TMDB_BASE_URL = process.env.REACT_APP_TMDB_BASE_URL;
const TMDB_API_KEY = process.env.REACT_APP_TMDB_API_KEY;
const TMDB_IMAGE_BASE_URL = process.env.REACT_APP_TMDB_IMAGE_BASE_URL;

const tmdbClient = axios.create({
  baseURL: TMDB_BASE_URL,
  params: {
    api_key: TMDB_API_KEY,
  },
});

export const getTrendingMovies = async (timeWindow = 'week') => {
  try {
    const response = await tmdbClient.get(`/trending/movie/${timeWindow}`);
    return response.data.results.map(movie => ({
      ...movie,
      poster_url: movie.poster_path ? `${TMDB_IMAGE_BASE_URL}${movie.poster_path}` : null,
      backdrop_url: movie.backdrop_path ? `${TMDB_IMAGE_BASE_URL}${movie.backdrop_path}` : null,
    }));
  } catch (error) {
    console.error('Error fetching trending movies:', error);
    throw error;
  }
};

export const getMovieDetails = async (movieId) => {
  try {
    const response = await tmdbClient.get(`/movie/${movieId}`);
    return {
      ...response.data,
      poster_url: response.data.poster_path ? `${TMDB_IMAGE_BASE_URL}${response.data.poster_path}` : null,
      backdrop_url: response.data.backdrop_path ? `${TMDB_IMAGE_BASE_URL}${response.data.backdrop_path}` : null,
    };
  } catch (error) {
    console.error('Error fetching movie details:', error);
    throw error;
  }
};



export const getUpcomingMovies = async () => {
  try {
    const response = await tmdbClient.get('/movie/upcoming');
    return response.data.results.map(movie => ({
      ...movie,
      poster_url: movie.poster_path ? `${TMDB_IMAGE_BASE_URL}${movie.poster_path}` : null,
      backdrop_url: movie.backdrop_path ? `${TMDB_IMAGE_BASE_URL}${movie.backdrop_path}` : null,
    }));
  } catch (error) {
    console.error('Error fetching upcoming movies:', error);
    throw error;
  }
};

export const getNowPlayingMovies = async () => {
  try {
    const response = await tmdbClient.get('/movie/now_playing');
    return response.data.results.map(movie => ({
      ...movie,
      poster_url: movie.poster_path ? `${TMDB_IMAGE_BASE_URL}${movie.poster_path}` : null,
      backdrop_url: movie.backdrop_path ? `${TMDB_IMAGE_BASE_URL}${movie.backdrop_path}` : null,
    }));
  } catch (error) {
    console.error('Error fetching now playing movies:', error);
    throw error;
  }
};

export const getMovieProviders = async (movieId) => {
  try {
    const response = await tmdbClient.get(`/movie/${movieId}/watch/providers`);
    return response.data.results;
  } catch (error) {
    console.error('Error fetching movie providers:', error);
    return null;
  }
};